var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    color: "#fff",
    width: "470px",
    height: "470px",
    viewBox: "0 0 470 470",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(-511.000000, -290.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(511.000000, 290.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "to-fill",
    id: "Rectangle",
    fill: "#220BAB",
    x: 0,
    y: 0,
    width: 470,
    height: 470,
    rx: 20
  }), /*#__PURE__*/React.createElement("text", {
    className: "to-color",
    id: "I-want-to-work-in-Li",
    fontFamily: "AvenirNext-Bold, Avenir Next",
    fontSize: 40,
    fontWeight: "bold",
    "line-spacing": 50,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 120,
    y: 282
  }, "I want to"), /*#__PURE__*/React.createElement("tspan", {
    x: 120,
    y: 332
  }, "work in"), /*#__PURE__*/React.createElement("tspan", {
    x: 120,
    y: 382
  }, "Lille, France")), /*#__PURE__*/React.createElement("g", {
    className: "to-color",
    id: "home",
    transform: "translate(153.000000, 53.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.013546,75.7472466 L85.2315826,1.96528321 C82.6089692,-0.650622768 78.36986,-0.650622768 75.7472466,1.96528321 L1.96528321,75.7472466 C-0.650622768,78.36986 -0.650622768,82.6156767 1.96528321,85.2315826 C3.22628404,86.4925835 4.92997665,87.1968659 6.70745122,87.1968659 L15.0917652,87.1968659 C16.0173935,87.1968659 16.768628,87.9481004 16.768628,88.8737287 L16.768628,154.271378 C16.768628,157.973891 19.7735662,160.978829 23.4760793,160.978829 L62.0439238,160.978829 C62.969552,160.978829 63.7207866,160.227595 63.7207866,159.301966 L63.7207866,127.441573 C63.7207866,118.178583 71.2264245,110.672945 80.4894146,110.672945 C89.7524048,110.672945 97.2580427,118.178583 97.2580427,127.441573 L97.2580427,159.301966 C97.2580427,160.227595 98.0092772,160.978829 98.9349055,160.978829 L137.50275,160.978829 C141.205263,160.978829 144.210201,157.973891 144.210201,154.271378 L144.210201,88.8737287 C144.210201,87.9481004 144.961436,87.1968659 145.887064,87.1968659 L154.271378,87.1968659 C157.973891,87.1968659 160.978829,84.1919277 160.978829,80.4894146 C160.978829,78.7119401 160.267839,77.00154 159.013546,75.7472466 Z M80.4894146,80.4894146 C71.2264245,80.4894146 63.7207866,72.9837767 63.7207866,63.7207866 C63.7207866,54.4577965 71.2264245,46.9521585 80.4894146,46.9521585 C89.7524048,46.9521585 97.2580427,54.4577965 97.2580427,63.7207866 C97.2580427,72.9837767 89.7524048,80.4894146 80.4894146,80.4894146 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("text", {
    className: "to-color",
    id: "Discover-my-dream-jo",
    fontFamily: "AvenirNext-Medium, Avenir Next",
    fontSize: 18,
    fontWeight: 400,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 215,
    y: 441
  }, "Discover my dream job")), /*#__PURE__*/React.createElement("g", {
    color: "to-color",
    id: "arrow-right",
    transform: "translate(423.000000, 428.000000)",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,8 L16,8",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "8 0 16 8 8 16"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.09a7bcdf6535c60a02f5077addb0be21.svg";
export { ForwardRef as ReactComponent };